import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useApp } from "../../context/AppContext";
import usePWADetection from "../../hooks/usePWADetection";
import usePageData from "../../hooks/usePageData";
import { generateOnboardingPathAndKey, handleRedirect } from "../../utils/CommonFunctions";

const PWAHeader = () => {
  const { t } = useTranslation();
  const { isPWA } = usePWADetection();
  const { content, name } = usePageData();
  const { configs } = useApp();
  const location = useLocation();
  const navigate = useNavigate();
  const showMenu = useMemo(
    () => location.pathname !== "/menu" && !!window.config.pages.menu,
    [location]
  );
  const onboardingRoutes = useMemo(() => {
    const routes = new Set();
    configs.flowModule.before.forEach((config) => {
      config.components.forEach(({ Component }, j) => {
        const { path } = generateOnboardingPathAndKey(Component, j, true, config.name);
        routes.add(`/${path}`);
      });
    });
    return Array.from(routes);
  }, [configs]);
  const currentlyOnboarding = useMemo(
    () => onboardingRoutes.some((route) => route === location.pathname),
    [onboardingRoutes, location]
  );
  const showBack = useMemo(() => name !== "homepage", [name]);

  if (!isPWA || currentlyOnboarding) return null;
  return (
    <div className="pwa-header">
      <div className="pwa-header-title-container">
        {showBack && (
          <button className="back" onClick={() => navigate(-1)}>
            {t("PWA.Back")}
          </button>
        )}
        <div className="pwa-header-title">{content.pageTitle}</div>
      </div>
      {showMenu && (
        <button
          className="pwa-header-menu-link"
          onClick={() =>
            handleRedirect(
              { type: "IN_APP", destinationPageId: "menu" },
              navigate,
              t("PWA.Menu"),
              name
            )
          }
        >
          {t("PWA.Menu")}
        </button>
      )}
    </div>
  );
};

export default PWAHeader;
